<template>
  <AgreementModal v-if="isShownAgreementModal && viewer" :viewer="viewer" />
  <CreditCardRegistrationModal
    v-if="!isShownAgreementModal && isShownCreditCardRegistractionModal"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AgreementModal from '@/components/organisms/AgreementModal/AgreementModal.vue'
import CreditCardRegistrationModal from '@/features/contract/components/CreditCardRegistrationModal/CreditCardRegistrationModal.vue'
import type {
  ModalManagerViewerFragment,
  ModalManagerContractFragment,
} from './ModalManager.generated'
import { PaymentMethod, ContractType } from '@/types/schema.generated'

const props = defineProps<{
  viewer: ModalManagerViewerFragment | null
  contract: ModalManagerContractFragment | null
}>()

const isShownAgreementModal = computed(
  () =>
    props.viewer?.requiredAgreementTerms != null &&
    props.viewer.requiredAgreementTerms.length > 0
)

const isShownCreditCardRegistractionModal = computed(
  () =>
    props.contract != null &&
    !props.contract.isCreditCardAvailable &&
    props.contract.paymentMethod === PaymentMethod.Stripe &&
    props.contract.contractType === ContractType.Individual
)
</script>
